import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Logo from '../Logo';
import ShoppingBag from '../ShoppingBag';
import WishList from '../WishList';
import Overlay from '../Overlay';
import ItemInnerMenuWap from '../ItemInnerMenuWap';
import InnerSubmenuWap from './InnerSubmenuWap';
import ItemsInnerSubmenuWap from './ItemsInnerSubmenuWap';
import NewItemsInnerSubMenuWap from "./NewItemsInnerSubmenuWap"
import SearchBar from '../SearchBar';
import serverClientUtil from '../../../../utils/serverClientUtil';
import commonUtil from './../../../../utils/commonUtil';
import { handleUserLogout } from '../../../../pages/Accounts/createAccount/actions';
import {
  assistanceIcon,
  benefitsIcon,
  hamburguerMenuIcon,
  myCreditIcon,
  myPurchasesIcon,
  userCloseSessionIcon,
  categoryIconsSubMenu
} from '../svgIcons';
import { withRouter } from 'react-router';

const applicationRoutes = commonUtil.getApplicationRoutes();

const iconsMenu = [
  myPurchasesIcon('#333333'),
  myCreditIcon('#333333'),
  benefitsIcon('#333333'),
  assistanceIcon('#333333'),
];
const categoriesLabel = 'Categorías';
const servicesLabel = 'Servicios';
const otherSitesLabel = 'Otros sitios';

@connect(
  store => ({
    user: store.user.data,
  }),
)

class HeaderBrandWap extends Component {
  constructor(props) {
    super(props);
    const { user = {} } = this.props;
    const result = user?.result || {};
    const { lastName, firstName, profileId = false, emailId } = result;

    this.infoSession = {
      name: firstName,
      lastNameFather: lastName,
      hasActiveSession: profileId,
      emailId,
    };

    this.state = {
      textLabel: '',
      showMenu: null,
      showSubMenu: null,
      setDataSubmenu: [[]],
      setDataInnerSubmenu: [],
      setDataInnerSubmenuNested: {},
    };
  }

  componentDidMount() {
    const menuPathsConfig = this.props.menuWapPathsConfigLogged
      ?.filter(item => item.label !== 'Mesa de regalos')
      ?.map((itemData, index) => ({
        url: itemData.url,
        label: itemData.label,
        heading: index,
        icon: iconsMenu[index],
      }))

    const resultData = (this.infoSession.hasActiveSession)
      ? menuPathsConfig
      : menuPathsConfig.filter(item => item.label !== 'Beneficios');

    this.setMenuData(resultData);
  }

  handleLogoutFn = () => {
    const { emailId } = this.infoSession;
    const { handleLogoutWithAuth0 } = this.props;
    const url = serverClientUtil.getLPFullURL();
    handleLogoutWithAuth0(emailId, this.props.handleUserLogout, url);
  }

  setMenuData = menuPathsConfig => this.setState({
    ...this.state,
    setDataSubmenu: [menuPathsConfig],
  });

  shouldShowMenu = () => {
    this.setState({
      ...this.state,
      showMenu: !this.state.showMenu,
      showSubMenu: this.state.showSubMenu && false,
      setDataInnerSubmenuNested: {},
    });

    // TODO: Create this in utils file to avoid repeat code.
    if (!this.state.showMenu) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('noscroll');
      return;
    }

    document.body.classList.remove('noscroll');
  }

  setNewDataSubmenusWap = (typeOfSubMenu) => {
    const { megamenu, services, otherSites = [] } = this.props;
    const childCategories = megamenu.l1Categories;

    if (typeOfSubMenu === categoriesLabel){
      return childCategories.map(category=>{
        return category.allMeta;
      });
    } 
    if (typeOfSubMenu === servicesLabel) return services;
    if (typeOfSubMenu === otherSitesLabel) return otherSites;
    return [];
  }

  setDataSubmenusWap = (typeOfSubMenu) => {
    const { megamenu, services, otherSites = [] } = this.props;
    const childCategories = megamenu.l1Categories;

    if (typeOfSubMenu === categoriesLabel) return childCategories;
    if (typeOfSubMenu === servicesLabel) return services;
    if (typeOfSubMenu === otherSitesLabel) return otherSites;
    return [];
  }

  shouldShowSubMenu = (typeOfSubMenu = '', isActiveSumenu) => {
    this.setState({
      ...this.state,
      showSubMenu: isActiveSumenu,
      setDataInnerSubmenu: [...this.setNewDataSubmenusWap(typeOfSubMenu)],
      textLabel: typeOfSubMenu,
    });
  }

  handleClickNested = (values, titleBtn) => {
    this.setState({ ...this.state, setDataInnerSubmenuNested: { values, titleBtn } });
  }

  hideSubmenuNested = () => this.setState({ ...this.state, setDataInnerSubmenuNested: {} });

  componentDidUpdate(prevProps) {
  const prevPath = prevProps.routerPaths?.location?.pathname;
  const currentPath = this.props.routerPaths?.location?.pathname;

  if (prevPath !== currentPath) {
    this.setState({
      showMenu:  applicationRoutes.home === currentRoute ? true : false,
    });
  }
}

  render() {
    const { showMenu, showSubMenu, setDataInnerSubmenuNested } = this.state;
    const { handleLoginWithAuth0, routerPaths, returnClickHandler } = this.props;
    const currentRoute = (routerPaths && routerPaths.location && routerPaths.location.pathname) || '';

    const getStylesDivSearch = () => {
      if (!this.props.hideSearch) return { display: 'none' };
      return { display: 'flex', placeContent: 'center' };
    };

    const isAgent = this.props.cscAdminProfile?.isAgent || false;

    return (
      <Fragment>
        <div className="wrapHeaderBrandContainer">
          <section className="headerBrandContainer aligmentWap">
            {
              applicationRoutes.home === currentRoute ? (
                <button className="buttonMenuHamburguerIcon" onClick={this.shouldShowMenu}>
                  {hamburguerMenuIcon}
                </button>
              ) : (
                <div
                  className="col-xs-2 returnIcon"
                  onClick={e => returnClickHandler(e)}
                >
                  <span className="icon-flecha_header_izquierda" />
                </div>
              )
            }
            <Logo />
            <WishList hasActiveSession={this.infoSession.hasActiveSession} />
            <ShoppingBag />
          </section>
          <div className={'typeaheadContainer'} style={getStylesDivSearch()}>
            <SearchBar />
          </div>
        </div>
        {
          showMenu &&
          <Overlay
            handleActionOverlay={this.shouldShowMenu}
            styles={{ styleTop: '112px', zIndex: 1 }}
          />
        }
        <div
          id="inner-menuWap"
          className={`innermenu ${(showMenu)
              ? 'slideInnerMenu'
              : 'slideToHidden'
            } `}
        >
          {this.state.setDataSubmenu.map((subMenu, menuIndex) => (
            <div key={`${subMenu}-${menuIndex}}`} className="cardMenuInnerContainer lpMenu">
              <ItemInnerMenuWap
                email={this.infoSession.emailId}
                subMenu={subMenu}
                menuIndex={menuIndex}
                infoSession={this.infoSession}
                shouldShowMenu={this.shouldShowMenu}
                handleLoginWithAuth0={handleLoginWithAuth0}
              />
              <InnerSubmenuWap
                handleClick={() => this.shouldShowSubMenu(categoriesLabel, true)}
                text={categoriesLabel}
                className="aditionalStyleForInnerSubmenu"
                icon={categoryIconsSubMenu}
              />
              <div className='liverpoolSubMenuContainer'>
              {
                subMenu.filter((item) => {
                  if(isAgent){
                    return item.label.toLowerCase().trim() !== 'mi crédito';
                  } else {
                    return item;
                  }
                }).map(item => (
                  <div key={`${menuIndex}-${item.label}`} className={'aligmentItems'}>
                    <a
                      className={`${'iconAligment'} ${'innerMenuSectionTitle'}`}
                      href={serverClientUtil.getNavUrl(item.url)}
                      onClick={e => this.shouldShowMenu(e, item.label)}
                    >
                      {item.icon}
                      {/* <h1 className={`${innerMenuSectionTitle === item.heading ? 'activeLink' : ''}`}>{ item.title }</h1> */}
                      <span>{item.label}</span>
                    </a>
                  </div>
                ))
              }
              </div>
              {!isAgent && <InnerSubmenuWap handleClick={() => this.shouldShowSubMenu(servicesLabel, true)} text={servicesLabel} />}
              <InnerSubmenuWap
                handleClick={() => this.shouldShowSubMenu(otherSitesLabel, true)}
                text={otherSitesLabel}
              />
              {
                (this.infoSession.hasActiveSession) && (
                  <div className="closeSessionWapContainer">
                    {userCloseSessionIcon}
                    <button onClick={this.handleLogoutFn} className={'closeSessionWap resetDefaultStyleBtn'}>
                      Cerrar sesión
                    </button>
                  </div>
                )
              }
            </div>
          ))}
        </div>
        <div
          className={`
          ${(showSubMenu)
              ? 'slideInnerSubMenu'
              : 'slideToHiddenSubMenu'
            }
        `}
        >
          <NewItemsInnerSubMenuWap
            handleClickNested={this.handleClickNested}
            data={this.state.setDataInnerSubmenu}
            handleClick={this.shouldShowSubMenu}
            textLabel={this.state.textLabel}
          />
        </div>

        <div
          className={`
          ${(setDataInnerSubmenuNested.values && Object.keys(setDataInnerSubmenuNested.values).length)
              ? 'slideInnerSubMenuNested'
              : 'slideToHiddenSubMenuNested'
            }
        `}
        >
          <button
            className="resetDefaultStyleBtn innerSubmenuBtn returnBtnWap"
            onClick={() => this.hideSubmenuNested()}
          >
            <span
              className="chevron chevronLeft right chevronLeftInnerSubmenuWap"
              style={{
                marginTop: '-2px',
              }}
            />
            <span>{setDataInnerSubmenuNested.titleBtn}</span>
          </button>
          <ul className="listContainer">
            {
              setDataInnerSubmenuNested.values && setDataInnerSubmenuNested.values.map(item => (
                <li
                  onClick={() => window.location.href = item.url}
                  className="itemListContainer"
                >
                  {item.label || item.text}
                </li>
              ))
            }
          </ul>
        </div>

      </Fragment>
    );
  }
}

const matchDispatchToProps = dispatch => bindActionCreators({ handleUserLogout }, dispatch);

export default withRouter(connect(null, matchDispatchToProps)(HeaderBrandWap));
